import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const jellyfin = defineConnector({
  identifier: "jellyfin",
  name: "Jellyfin",
  tagLine: "Media server and streaming",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `MediaBrowser Token="${app.secret.apiKey}"`,
      },
    ]),
  steps: [
    {
      title: "Get your Jellyfin API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Jellyfin, go to **Dashboard → API Keys** and create a new API key.",
        },
      ],
    },
    {
      title: "Enter your Jellyfin details",
      items: [
        {
          kind: "url",
          label: "Jellyfin server URL",
          required: true,
          placeholder: "https://jellyfin.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Jellyfin server.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/System/Info`,
  },
});
